<template>
  <b-modal
    id="modal-preview-email"
    header-bg-variant="primary"
    size="lg"
    scrollable
    centered
    no-close-on-esc
    no-close-on-backdrop
    :title="$t('dashboard.scheduler.action.preview')"
  >
    <b-row class="justify-content-center">
      <b-col sm="12">
        <p v-html="emailBody"></p>
        <hr />
      </b-col>
      <b-col md="10">
        <b-card>
          <b-card-body class="p-0 my-3">
            <template v-if="getContent.length == 0">
              <component :is="currentPreview" />
            </template>
            <template v-else>
              <div class="mc-scheduler-digest-preview__metabase">
                <MetabaseContent :id="widget?.reportSchedulerContent[0]?.contentId" :link="link" />
              </div>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="12">
        <hr />
        <b-alert show variant="primary" class="mc-alert mt-3">
          <span class="mc-alert__text">
            {{ alertContent }}
          </span>
        </b-alert>
      </b-col>
      <div class="d-flex justify-content-center">
        <McButton text="Pelajari Lebih Lanjut" size="sm" disabled />
      </div>
    </b-row>

    <template #modal-footer="{ cancel }">
      <b-row class="modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="modal__filter-footer-btn">
          <McButton
            variant="primary"
            class="me-2"
            :text="$t('global.action.close')"
            @click="cancel"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import Daily from '../Email/Daily'
import Weekly from '../Email/Weekly'
import Monthly from '../Email/Monthly'
import McButton from '@/components/McButton'
import McBadge from '@/components/McBadge'
import MetabaseContent from '../form/MetabaseContent.vue'
export default {
  components: {
    Daily,
    Weekly,
    Monthly,
    McButton,
    McBadge,
    MetabaseContent,
  },
  data() {
    return {
      emailBody:
        '<p>Dear Team,</p> <br/> <p>Berikut ini merupakan summary reminder untuk PT Buana Indah</p>',
      alertContent: null,
      widget: {},
      link: null,
      getContent: [],
    }
  },
  computed: {
    currentPreview() {
      switch (this.widget.period) {
        case 'd':
          return 'Daily'
        case 'w':
          return 'Weekly'
        case 'm':
          return 'Monthly'
        default:
          return 'Monthly'
      }
    },
  },
  methods: {
    showModal(content, alert, widget, res) {
      if (content != null) this.emailBody = content
      this.getContent = res
      this.alertContent = alert
      this.widget = widget
      this.link = res?.length > 0 ? res[0].embed_link : null
      this.$bvModal.show('modal-preview-email')
    },
    hideModal() {
      this.$bvModal.hide('modal-preview-email')
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-success {
  .mc-fa {
    &:before {
      color: $success;
    }
  }
}
.widget-danger {
  .mc-fa {
    &:before {
      color: $danger;
    }
  }
}
.text-info.text-soft {
  color: rgba(80, 165, 241, 0.25) !important;
}
</style>
